import { render, staticRenderFns } from "./ModalConfirmDeletePickupPoint.vue?vue&type=template&id=2c5f44ca&"
import script from "./ModalConfirmDeletePickupPoint.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmDeletePickupPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports